import React, { useState, useEffect } from 'react';
import { Modal, Button, Table, Spinner, Alert } from 'react-bootstrap';
import UtilityService from '../../services/UtillityServices/UtilityService';

const RendicontazioneDettaglioModal = ({ show, onHide, rendicontazione, dettaglio }) => {
    
    // Stato interno per gestire il caricamento e i dati visualizzati
    const [isLoading, setIsLoading] = useState(true);
    const [dettaglioData, setDettaglioData] = useState([]);

    // Questo useEffect si attiva quando la modale viene mostrata o quando i dati arrivano
    useEffect(() => {
        if (show) {
            // Se la prop 'dettaglio' contiene dati, li usiamo e fermiamo il caricamento
            if (dettaglio && dettaglio.length > 0) {
                setDettaglioData(dettaglio);
                setIsLoading(false);
            } else {
                // Se la modale è visibile ma i dati non sono ancora arrivati, mostriamo lo spinner
                setIsLoading(true);
            }
        } else {
            // Quando la modale viene chiusa, resettiamo tutto per la prossima apertura
            setIsLoading(true);
            setDettaglioData([]);
        }
    }, [dettaglio, show]); // L'effetto si riattiva quando 'dettaglio' o 'show' cambiano

    const totaleCalcolato = dettaglioData.reduce((sum, item) => 
        sum + parseFloat(item.provvigione_superpartner || item.provvigione_partner || 0), 0);

    return (
        <Modal show={show} onHide={onHide} size="xl" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Dettaglio Rendicontazione: {rendicontazione?.nome_agenzia || rendicontazione?.nome_superpartner}
                    <span className="d-block small text-muted">Periodo: {rendicontazione?.mese}/{rendicontazione?.anno}</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading ? (
                    <div className="text-center p-5"><Spinner /></div>
                ) : (
                    <>
                        <Table striped bordered hover responsive>
                            <thead className="table-light">
                                <tr>
                                    <th>Corsista</th>
                                    <th>Corso</th>
                                    <th>Data Iscrizione</th>
                                    <th className="text-end">Provvigione</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dettaglioData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{`${item.corsista_cognome} ${item.corsista_nome}`}</td>
                                        <td style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                            {item.denominazione_corso}
                                        </td>
                                        <td>{UtilityService.formatDate(item.data_iscrizione)}</td>
                                        <td className="text-end">€ {parseFloat(item.provvigione_superpartner || item.provvigione_partner || 0).toFixed(2)}</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr className="table-light fw-bold">
                                    <td colSpan="3" className="text-end fs-5">Totale Verificato:</td>
                                    <td className="text-end fs-5">€ {totaleCalcolato.toFixed(2)}</td>
                                </tr>
                            </tfoot>
                        </Table>
                        
                        {totaleCalcolato.toFixed(2) !== parseFloat(rendicontazione?.totale_provvigioni).toFixed(2) &&
                            <Alert variant="danger">
                                Attenzione: Il totale calcolato (€ {totaleCalcolato.toFixed(2)}) non corrisponde al totale dichiarato (€ {parseFloat(rendicontazione?.totale_provvigioni).toFixed(2)}).
                            </Alert>
                        }
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Chiudi
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RendicontazioneDettaglioModal;